import "./ButtonWithIconAlt.scss";

type TButtonWithIconProps = {
    type?: string, size?: string, iconImg?: string
    icon?: any, title: string, titleStyle?: string, cbClick?: () => void
};

/**
 * This element renders a button with icon and title. 
 * @param {string} type - the ending type of bootstrap btn
 * @param {string} size - the size of the button --small, --medium, --big, --alt, --full
 * @param {string} iconImg - the icon img src
 * @param {string} icon - icon element from `bootstrap-icons` library
 * @param {string} title - plain text.
 * @param titleStyle
 * @param {function} cbClick - callback function to be executed when the button is clicked.
 * @returns {JSX.Element}
 */

const ButtonWithIconAlt = ({type, size, iconImg, icon, title, titleStyle, cbClick}: TButtonWithIconProps) => {

    
    return (
        <div className={`ButtonWithIcon ${size ? "--" + size : ""}`}>
            <button onClick={cbClick} 
                className={`btn btn-${type ? type : "primary"}`}>
                {icon ?
                    <i className={"customIcon " + icon}></i> :
                    <img className="customIcon" src={iconImg} alt="icon" />
                }
                <span className={"customText "+titleStyle} >{title}</span>
            </button>
        </div>
    );
};

export default ButtonWithIconAlt;
